<template>
  <div v-loading="loading">
    <div class="dup-head">
      <el-select v-model="currentCate" size="small" filterable placeholder="筛选职能模块" @change="loadData">
        <el-option v-for="item in cateOptions" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <el-button type="primary" size="small" style="float:right" @click="mergeZhufu">处理系统中所有主副合并</el-button>
    </div>
    <div style="margin-top: 30px">
      <el-card v-for="(dt, k) in data" :key="dt._id">
        <div class="dup-wapper">
          <table class="dup-table" cellspacing="0">
            <tr class="dup-row">
              <td class="dup-col dup-col-num" :rowspan="dt.item.length + 1">
                {{ (currentPage - 1) * pageSize + k + 1 }}
              </td>
              <td class="dup-col">主副标注</td>
              <td class="dup-col">操作</td>
              <td v-for="head in tableHeads" :key="head.label" class="dup-col">{{ head.label }}</td>
            </tr>
            <tr v-for="item in dt.item" :key="item._id" class="dup-row">
              <td class="dup-col">
                <span
                  class="dup-action"
                  :class="{ 'dup-action-active': item.mergeType == '主' }"
                  @click="changeZhufu(item, '主')"
                >
                  主
                </span>
                <span
                  class="dup-action"
                  :class="{ 'dup-action-active': item.mergeType == '副' }"
                  @click="changeZhufu(item, '副')"
                >
                  副
                </span>
              </td>
              <td class="dup-col">
                <template v-if="item['手机']">
                  <span class="dup-action dup-action-outline" @click="clearPhone(item)"> 清空手机 </span>
                  <span class="dup-action dup-action-outline" @click="moveZuo(item)"> 移到座机 </span>
                </template>
              </td>
              <td v-for="head in tableHeads" :key="item._id + head.label" class="dup-col" :title="item[head.label]">
                <span v-if="head.label == '姓名'" class="radish-link" @click="clickName(item)">{{
                  item[head.label]
                }}</span>
                <span v-else>{{ item[head.label] }}</span>
              </td>
            </tr>
          </table>
        </div>
      </el-card>
      <el-pagination
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="loadData"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import tableHeads from './constant/table-heads-dup'

export default {
  mixins: [tableHeads],
  data: function() {
    return {
      loading: false,
      cateOptions: [],
      mainCateOptions: [],
      currentCate: '',
      mainCate: '',
      currentPage: 1,
      pageSize: 50,
      data: [],
      total: 0,
      dialogVisible: false,
      currentItem: {},
    }
  },
  mounted() {
    this.loadCate()
    this.loadData()
  },
  methods: {
    loadData: async function() {
      this.loading = true
      const res = await app.service('radish').listDup({
        page: this.currentPage,
        limit: this.pageSize,
        cate: this.currentCate,
      })
      if (res.status == 'success') {
        this.data = res.data
        this.total = res.total
        // console.log(res)
      }
      this.loading = false
    },
    loadCate: async function() {
      if (!app.categories) {
        await app.getCats()
      }
      const catData = app.categories
      if (catData && catData.length > 0) {
        const tmp = catData.map(item => item['名称'])
        const prem = app.user['SL权限']
        const role = app.user['角色']
        let tmp2 = []
        if (!role || (!role.includes('管理员') && !role.includes('业务助理'))) {
          if (!prem || prem.length == 0) {
            tmp2 = []
          } else {
            const catArr = prem.split(';')
            tmp2 = tmp.filter(c => catArr.includes(c))
          }
        } else {
          tmp2 = JSON.parse(JSON.stringify(tmp))
        }
        this.cateOptions = tmp2
      }
    },
    modifyData: async function(item, data) {
      const res = await app.service('radish').modifyById({ _id: item._id, data })
      if (res.status == 'success') {
        this.data = this.data.map(dt => {
          if (dt._id === item['手机']) {
            dt.item = dt.item.map(d => {
              if (d._id === item._id) {
                Object.keys(data).map(field => {
                  d[field] = data[field]
                })
              }
              return d
            })
          }
          return dt
        })
      } else {
        this.$message.error(res.msg)
      }
    },
    changeZhufu: function(item, type) {
      this.modifyData(item, { mergeType: type })
    },
    clearPhone: function(item) {
      this.modifyData(item, { 手机: '' })
    },
    moveZuo: function(item) {
      this.modifyData(item, { 手机: '', 座机: item['手机'] })
    },
    mergeZhufu: function() {
      app.service('radish').mergeZhufu()
      this.$message.info({ duration: 3000, message: '主副合并处理已提交，正在后台处理中，稍后将消息通知处理结果' })
    },
    close: function() {
      this.dialogVisible = false
      this.currentItem = {}
      this.mainCate = ''
    },
    clickName: function(item) {
      window.open(`${window.frontend}/#/radish-detail-blank/${item._id}`, '_blank')
    },
  },
}
</script>
<style>
.dup-wapper {
  overflow: auto;
}
.dup-table {
  border-top: 1px solid #ddd;
  border-left: 1px solid #ddd;
  width: 4850px;
  transform: none;
}
.dup-col {
  width: 100px;
  box-sizing: border-box;
  border-bottom: 1px solid #ddd;
  border-right: 1px solid #ddd;
  height: 24px;
  line-height: 24px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dup-col.dup-col-num {
  width: 50px;
}
.dup-action {
  margin: 2px;
  background-color: #f5f7fa;
  color: #c0c4cc;
  cursor: pointer;
}
.dup-action.dup-action-active {
  background-color: #409eff;
  color: #fff;
}
.dup-action.dup-action-outline {
  border: 1px solid #409eff;
  color: #409eff;
}
.dup-head {
  position: fixed;
  top: 60px;
  padding: 5px 20px;
  width: 100%;
  background: #fff;
}
</style>
